import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { Waypoint } from 'react-waypoint';
import Comment from '../../../Comment/presets/Comment';
import { updateCommentOffsetEveryPage } from '../../helpers';
const OffsetTrackingComment = (props)=>{
    const onEnter = ()=>updateCommentOffsetEveryPage(props.comment, props.index);
    return /*#__PURE__*/ React.createElement(Waypoint, {
        topOffset: "-100px",
        bottomOffset: "100%",
        onEnter: onEnter
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Comment, _extends({}, props))));
};
OffsetTrackingComment.displayName = 'OffsetTrackingComment';
export default OffsetTrackingComment;
